module.exports = __webpack_public_path__ + "img/home_vr_icon.af62f98.png";